import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InteractionsRoutingModule } from './interactions-routing.module';
import { InteractionsComponent } from './interactions.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';

@NgModule({
  declarations: [
    InteractionsComponent
  ],
  imports: [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  InteractionsRoutingModule,
  NgZorroAntdModule,
  SharedModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class InteractionsModule { }
